import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PropertiesTableComponent } from './properties-table/properties-table.component';
import { CommonMaterialModule } from '@nuso/common/ui-material';
import { SpinnerComponent } from './spinner/spinner.component';
import { BreadcrumbsNavComponent } from './breadcrumbs-nav/breadcrumbs-nav.component';
import { UserMenuComponent } from './user-menu/user-menu.component';

export * from './properties-table/properties-table.component';
import { TranslateModule } from '@ngx-translate/core';
import { CopyClipboardDirective } from './copy-clipboard/copy-clipboard.directive';
import { NestedMenuComponent } from './nested-menu/nested-menu.component';
import { ConfirmDialogComponent } from './confirm/confirm-dialog/confirm-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { ConfirmService } from './confirm/confirm.service';
import { RouterModule } from '@angular/router';
import { WarningBoxComponent } from './warning-box/warning-box.component';
import { CommonPipesModule } from '@nuso/common/util-pipes';
import { CountdownComponent } from './countdown/countdown.component';
import { CommonUiMaterialFormsModule } from '@nuso/common/ui-material-forms';
import { PhoneMaskDirective } from './phone-mask/phone-mask.directive';
import { NumbersOnlyDirective } from './numbers-only/numbers-only.directive';
import { ConfirmWithStatusDialogComponent } from './confirm-with-status-dialog/confirm-with-status-dialog.component';
import { DisplayDialogComponent } from './display-dialog/display-dialog.component';
import { HoverDialogComponent } from './hover-dialog/hover-dialog.component';
import { DialogService } from './dialog.service';
import { ConfirmDialog2Component } from './confirm/confirm-dialog/confirm-dialog2.component';
import { TableColumnSelectorComponent } from './table-column-selector/table-column-selector.component';
import { TableColumnSelectorService } from './table-column-selector.service';
import { SortableMultiSelectComponent } from './sortable-multi-select/sortable-multi-select.component';
import { FormsModule } from '@angular/forms';
import { MatListModule } from '@angular/material/list';
import { DragDropModule } from '@angular/cdk/drag-drop';

export * from './confirm/confirm.service';
export * from './confirm/confirm-dialog/confirm-dialog.component';
export * from './dialog.service';
export * from './table-column-selector.service';
export * from './sortable-multi-select/sortable-multi-select.component';

export { ConfirmWithStatusDialogComponent, DisplayDialogComponent };

@NgModule({
  imports: [
    CommonModule,
    CommonMaterialModule,
    MatDialogModule,
    TranslateModule,
    RouterModule,
    CommonPipesModule,
    CommonUiMaterialFormsModule,
    FormsModule,
    MatListModule,
    DragDropModule,
  ],
  declarations: [
    PropertiesTableComponent,
    BreadcrumbsNavComponent,
    SpinnerComponent,
    CopyClipboardDirective,
    NestedMenuComponent,
    ConfirmDialogComponent,
    ConfirmWithStatusDialogComponent,
    DisplayDialogComponent,
    UserMenuComponent,
    WarningBoxComponent,
    CountdownComponent,
    PhoneMaskDirective,
    NumbersOnlyDirective,
    HoverDialogComponent,
    ConfirmDialog2Component,
    TableColumnSelectorComponent,
    SortableMultiSelectComponent,
  ],
  providers: [ConfirmService, DialogService, TableColumnSelectorService],
  exports: [
    PropertiesTableComponent,
    BreadcrumbsNavComponent,
    SpinnerComponent,
    CopyClipboardDirective,
    NestedMenuComponent,
    UserMenuComponent,
    WarningBoxComponent,
    CountdownComponent,
    PhoneMaskDirective,
    NumbersOnlyDirective,
    HoverDialogComponent,
    SortableMultiSelectComponent,
  ],
})
export class CommonUiComponentsModule {}
export * from './breadcrumbs-nav/breadcrumbs';
